import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create axios instance with interceptor for JWT token
const axiosInstance = axios.create({
    baseURL: API_URL
});

// Add token to requests
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const draftService = {
    /**
     * Save a new draft or update existing draft
     */
    saveDraft: async (draftData) => {
        try {
            const response = await axiosInstance.post('/api/drafts/save', draftData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to save draft' };
        }
    },

    /**
     * Get all drafts for current user
     */
    getAllDrafts: async () => {
        try {
            const response = await axiosInstance.get('/api/drafts');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to fetch drafts' };
        }
    },

    /**
     * Get specific draft details
     */
    getDraft: async (draftId) => {
        try {
            const response = await axiosInstance.get(`/api/drafts/${draftId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to fetch draft' };
        }
    },

    /**
     * Delete a draft
     */
    deleteDraft: async (draftId) => {
        try {
            const response = await axiosInstance.delete(`/api/drafts/${draftId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to delete draft' };
        }
    },

    /**
     * Submit draft as form submission
     */
    submitDraft: async (draftId) => {
        try {
            const response = await axiosInstance.post(`/api/drafts/${draftId}/submit`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to submit draft' };
        }
    }
};

export default draftService;
